import { type StoreChatItem } from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const areMessageGroupsEqual = (
	previousGroup: ReadonlyArray<StoreChatItem> | undefined,
	nextGroup: ReadonlyArray<StoreChatItem>,
): previousGroup is ReadonlyArray<StoreChatItem> =>
	previousGroup !== undefined &&
	(previousGroup === nextGroup ||
		(previousGroup.length === nextGroup.length &&
			previousGroup.every((previousMessage, index) =>
				Object.is(previousMessage, nextGroup[index]),
			)));
